import { defineStore } from "pinia";
import axios from "axios";

export const useBundleStore = defineStore("bundle", {
  state: () => {
    return {
      bundle: {},
      variant: {},
      product: {},
      offer: {},
      availability: {},
      selected: {
        variant: 0,
        offer1: {},
        offer2: {},
        offer3: {},
      },
      filter: {
        pool1: 0,
        pool2: 0,
        pool3: 0,
      },
    };
  },
  actions: {
    async getBundleList() {
      const response = await axios({
        method: "post",
        url: "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:bundle.rest.api&action=getBundleList",
        params: {},
      });

      this.bundle = response.data.bundle?.bundles;
      this.variant = response.data.variant;
      this.product = response.data.product;
      this.offer = response.data.offer;
      this.availability = response.data.availability;

      this.selected.variant = this.variant[0]["ID"];
    },
    async addToCart() {
      window.BX.ajax
        .runComponentAction("orteka:bundle.rest.api", "addBundleToCart", {
          mode: "ajax",
          data: {
            productData: this.selected,
          },
        })
        .then(
          function (response) {
            console.log(response);
            document.location.href = "/personal/cart/";
          },
          function (response) {
            console.log(response);
          }
        );
    },
    setVariant(id) {
      this.selected.variant = id;
    },
    getProductById(id) {
      return this.product[id];
    },
    clearSelectedOffers() {
      this.selected.offer1 = {};
      this.selected.offer2 = {};
      this.selected.offer3 = {};
    },
    clearFilters() {
      this.filter.pool1 = 0;
      this.filter.pool2 = 0;
      this.filter.pool3 = 0;
    },
    setFilter(number, id) {
      this.filter["pool" + number] = id;
    },
  },
  getters: {
    getVariants(state) {
      return state.variant;
    },
    getSelectedVariant(state) {
      const selected = Object.values(state.variant).filter((variant) => {
        return variant.ID === state.selected.variant;
      });

      return selected[0];
    },
  },
});
